import { render, staticRenderFns } from "./LoginFlowStepEmail.vue?vue&type=template&id=2fcf85d1&scoped=true"
import script from "./LoginFlowStepEmail.vue?vue&type=script&lang=ts"
export * from "./LoginFlowStepEmail.vue?vue&type=script&lang=ts"
import style0 from "./LoginFlowStepEmail.vue?vue&type=style&index=0&id=2fcf85d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcf85d1",
  null
  
)

export default component.exports